/**
 * Стор тостов UI-kit (HeroUI). Синглтон на уровне модуля — общий для всех импортов.
 * Использование:
 *   const { toast } = useKitToast()
 *   toast({ color: 'success', title: 'Готово', description: '…' })
 * В корне приложения/лейаута должен быть смонтирован <UiKitToaster />.
 */
import { reactive } from 'vue'
import type { HuiColor } from './palette'

export type KitToastVariant = 'flat' | 'solid' | 'bordered'

/** Кнопка-действие внутри тоста (например, «Указать на карте»). */
export interface KitToastAction {
  label: string
  onClick: () => void
}

export interface KitToast {
  id: number
  title?: string
  description?: string
  color: HuiColor
  variant: KitToastVariant
  timeout: number
  closable: boolean
  action?: KitToastAction
}

export type KitToastOptions = Partial<Omit<KitToast, 'id'>>

const toasts = reactive<KitToast[]>([])
let seq = 0

export function pushToast(opts: KitToastOptions = {}): number {
  const id = (seq += 1)
  toasts.push({
    id,
    title: opts.title,
    description: opts.description,
    color: opts.color ?? 'default',
    variant: opts.variant ?? 'flat',
    timeout: opts.timeout ?? 5000,
    closable: opts.closable ?? true,
    action: opts.action,
  })
  return id
}

export function removeToast(id: number): void {
  const i = toasts.findIndex(t => t.id === id)
  if (i !== -1) toasts.splice(i, 1)
}

export function clearToasts(): void {
  toasts.splice(0, toasts.length)
}

export function useKitToast() {
  return { toasts, toast: pushToast, remove: removeToast, clear: clearToasts }
}
